/*
 * @Description: axios
 * @Autor: Ray7hw
 * @LastEditTime: 2020-12-02 15:30:15
 */
import axios from "axios"
import {
  Toast
} from 'vant';
import store from "@/store"
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    NProgress.start()
    if (store.state.token) {
      // 给请求头添加laohu-token
      config.headers["token"] = store.state.token;
    }
    // console.log("🚀 ~ file: request.js ~ line 38 ~ config", config)

    return config
  },
  error => {
    NProgress.done()
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    NProgress.done()
    const res = response.data
    const code = res.code !== '0000' && res.code !== 0
    var headType = response.headers["content-type"]
    console.log(code, res, res.code, headType)
    if (code && headType !== "image/jpeg" && headType !== "application/vnd.ms-excel;charset=utf-8") {
      // 退出登录以及未登录;
      if (res.code == "1199" || res.code == '1111') {
        setTimeout(() => {
          store.dispatch("user/resetToken").then(() => {
            window.location.reload()
          })
        }, 1 * 1000)
      }
      return Promise.reject(res)
    } else {
      return Promise.resolve(res)
    }
  },
  error => {
    // for debug
    // setTimeout(() => {
    //   store.dispatch("user/resetToken").then(() => {
    //     window.location.reload();
    //   });
    // }, 2 * 1000);
  }
)

export default service
